/* jslint browser: true,  devel: true */
import $ from "jquery";

window.app.controller("MenuCtrl", [
  "$scope",
  "$rootScope",
  "$element",
  "$animate",
  "$state",
  "$stateParams",
  "api",
  function($scope, $rootScope, $element, $animate, $state, $stateParams, api) {
    console.log("MenuCtrl:init");
    $scope.navigate = $state.go.bind($state);
    $scope.logout = api.Login.logout;

    $animate.on("removeClass", $element, function(element, phase) {
      if (phase === "close" && element.hasClass("state-item")) {
        $scope.$applyAsync(function() {
          $scope.appMenu.close();
        });
      }
    });

    // Close mobile menu when user taps outside it
    if (!window.isDesktop) {
      if ($rootScope.menuClickOutCheck) {
        $(document).off("click", $rootScope.menuClickOutCheck);
      }
      $rootScope.menuClickOutCheck = evt => {
        if (!$(evt.target).closest(".side-menu").length) {
          $scope.$applyAsync(() => $scope.appMenu.close());
        }
      };
      $(document).on("click", $rootScope.menuClickOutCheck);
    }
  }
]);

const microappIcons = {
  // 'Approvals': 'glyphicon-ok',
  // 'Timesheets': 'glyphicon-time',
  // 'Information': 'glyphicon-search',
  // 'News': 'glyphicon-list-alt',
  // 'My Profile': 'glyphicon-user',
  // 'My Benefits': 'glyphicon-heart-empty',
  // 'Leave Requests': 'glyphicon-briefcase',
  Approvals: "icon-approval",
  Timesheets: "icon-timesheet",
  Information: "icon-staffsearch",
  News: "icon-news",
  "My Profile": "icon-profile",
  "My Benefits": "icon-benefits",
  "Leave Requests": "icon-leave",
  Payroll: "icon-payroll"

  // 'glyphicon-cutlery': 'icon-health'
};

// TODO decide how to handle login/out more consistently
function logOut() {
  window.interceptor.logout();
}

function innerGoto($state, state) {
  try {
    $state.go(`${state}-async`);
  } catch (e) {
    $state.go(state);
  }
}

function getGoTo(url) {
  return () => window.open(url, "_blank");
}

const weightComp = (a, b) => a.weight - b.weight;

function buildMenuItem(def) {
  const addIcons = false;
  const title = def.categoryTitle || def.itemTitle;
  return {
    iconType: !def.iconType && addIcons ? "ms" : def.iconType || "material",
    icon:
      !def.icon && addIcons
        ? microappIcons[title] || null
        : def.icon || "play_arrow",
    text: title,
    submenu: def.items ? def.items.map(buildMenuItem) : undefined,
    linkTo: def.url && !def.isExternal ? def.url.substr(2) : undefined,
    onClick: def.url && def.isExternal ? getGoTo(def.url) : undefined
  };
}

window.app.directive("sideMenu", [
  "apiCall",
  function(apiCall) {
    function offset(el) {
      var rect = el.getBoundingClientRect();
      var scrollLeft =
        window.pageXOffset || document.documentElement.scrollLeft;
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
    }

    function showAbsolute(content, className, x, y) {
      const div = document.createElement("div");
      div.className = className;
      div.style.position = "absolute";
      div.style.left = x + "px";
      div.style.top = y + "px";
      div.style.zIndex = 999;
      div.style.overflow = "hidden";
      div.appendChild(content);
      document.body.appendChild(div);
      return div;
    }

    return {
      restrict: "A",
      scope: false,
      // transclude: true,
      template: (tElement, tAttrs) => {
        tElement.html(require("./menu.html"));
        tElement.addClass("side-menu");
      },
      controller: [
        "$scope",
        "$element",
        "$state",
        "$rootScope",
        "getAvatarSVG",
        function(scope, $element, $state, $rootScope, getAvatarSVG) {
          console.log("MenuDCtrl:init", scope);

          if (!$rootScope.userdata) {
            console.error("Skipping inner menu controller - no userdata yet");
            return;
          }

          if ($rootScope.publicMode) {
            console.log("Public mode - no token. Skipping menu");
            return;
          }

          if (!$rootScope.menu) {
            apiCall({
              endpoint: "enterprisePlatformConfig/menu/$/@/"
            }).then(function(res) {
              scope._menu = res;
              scope.menu = [
                ...scope._menu.categories.sort(weightComp),
                ...scope._menu.uncategorizedItems.sort(weightComp)
              ].map(buildMenuItem, false);
              scope.menu.unshift({
                icon: "home",
                iconType: "material",
                text: "Home",
                linkTo: "container"
              });
              scope.menu.push({
                icon: "exit_to_app",
                iconType: "material",
                text: "Logout",
                onClick: logOut
              });
              $rootScope.menu = scope.menu;
            });
          }

          scope.getAvatar = () => {
            const { userdata } = $rootScope;
            return (
              userdata.profileImageUrl ||
              getAvatarSVG(userdata.firstName + " " + userdata.lastName)
            );
          };

          function handleFloatHover(e) {
            scope.cloneHovered = e.type === "mouseenter";
            if (scope.cloneHovered) scope.originalHovered = false;
            //console.warn('Float hover event', { event, type: e.type, cloneHovered: scope.cloneHovered, target: e.target });
            setTimeout(checkHover, 50);
          }

          function handleLeftUlHover(e) {
            //console.warn('Left ul hover', e);
            if (e.clientX < 50) {
              checkHover(true);
            }
          }

          scope.handleHover = (item, e, sim) => {
            //console.warn('handleHover', { item, e });
            if (
              document.body.className.includes("mobile") &&
              e.type === "mouseout"
            ) {
              //console.warn('Skipping bad ng-mouseenter', e);
              return;
            }
            let element = e.target;
            scope.originalHovered = e.type === "mouseover";
            if (e.type === "mouseover") {
              if (scope.floatingItem) {
                checkHover(true);
              }
              if (document.querySelector(".side-menu.open:not(.cloned)"))
                return;
              scope.lastFloatTrigger = Date.now();

              // TODO maybe avoid these issues by using regular mouseenter
              while (element.tagName.toLowerCase() !== "li") {
                element = element.parentNode;
              }
              element = element.querySelector("span.menu-link");

              //console.warn('element is', element);
              const info = offset(element);
              const copy = angular.element(element.parentNode).clone()[0];
              copy.querySelector(".menu-link").onclick = e =>
                scope.handleItemClick(item, e);
              copy.childNodes[0].className += " cloned";
              copy.className = "open";

              const wrap = angular.element(
                '<div class="side-menu open cloned" style="height: auto">' +
                  '<ul class="menu-items">' +
                  "</ul>" +
                  "</div>"
              );
              wrap.find("ul").append(copy);
              var sub = wrap[0].querySelector("ul.submenu");
              if (sub) {
                sub.onmouseover = handleLeftUlHover;
                sub.querySelectorAll(".menu-link").forEach((link, i) => {
                  link.onclick = () => scope.handleItemClick(item.submenu[i]);
                });
              }
              wrap[0].onmouseenter = wrap[0].onmouseleave = handleFloatHover;
              scope.floatingElement = showAbsolute(
                wrap[0],
                "",
                info.left + 45,
                info.top
              );
              if (info.top < 52) {
                // don't show if partially scrolled off the top
                scope.floatingElement.style.display = "none";
              }
              scope.floatingItem = item;
            }

            setTimeout(checkHover, 1000);
          };

          function checkHover(force) {
            if (
              force ||
              (scope.floatingElement &&
                !scope.cloneHovered &&
                !scope.originalHovered)
            ) {
              $(scope.floatingElement).remove();
              scope.floatingElement = null;
              scope.floatingItem = null;

              // Shouldn't be necessary - added it JIC
              $(".side-menu.open.cloned").remove();
            }
          }

          scope.hideFloating = () => {
            if (scope.floatingElement) {
              checkHover(true);
            }
          };

          scope.handleItemClick = (item, e) => {
            if (Date.now() - scope.lastFloatTrigger < 50) {
              console.warn("Ignoring buggy click");
              return;
            }

            if (item.submenu) {
              if (scope.openItem === item) {
                scope.openItem = null;
              } else {
                scope.openItem = item;
              }
            }

            if (item.linkTo) {
              // TODO
              const state = item.linkTo
                .replace("my", "")
                .replace("hrpolicies", "content");
              innerGoto($state, state);
              // $state.go(state /* item.linkTo */);
            } else if (item.onClick) {
              item.onClick();
            }

            if (scope.floatingElement) {
              checkHover(true);
            }
            if (!window.isDesktop && (item.linkTo || item.onClick)) {
              scope.appMenu.close();
            }
          };

          scope.isActive = item => {
            return (
              (item.linkTo && $state.includes(item.linkTo)) ||
              (item.submenu &&
                item.submenu.some(
                  subitem => subitem.linkTo && $state.includes(subitem.linkTo)
                ))
            );
          };

          scope.isOpen = item => {
            return scope.isActive(item) || scope.openItem === item;
          };

          scope.getItemClasses = item => {
            var classes = [];
            if (scope.isOpen(item)) classes.push("open");
            if (scope.isActive(item)) classes.push("active");
            return classes.join(" ");
          };

          Object.assign(this, {
            isOpen: false,
            close: function(e) {
              if (this.isOpen) {
                this.isOpen = false;
                $element.removeClass("open");
              }
              if (e) {
                e.preventDefault();
              }
              window.appMenuOpen = this.isOpen;
            },
            open: function(e) {
              if (scope.app && scope.appCalendar && scope.appCalendar.isOpen) {
                scope.appCalendar.close();
              } else if (!this.isOpen) {
                this.isOpen = true;
                $element.addClass("open");
              }
              if (e) e.stopPropagation();
              window.appMenuOpen = this.isOpen;
            },
            toggle: function(e) {
              if (this.isOpen) {
                this.close(e);
              } else {
                this.open(e);
              }
            }
          });
          scope.appMenu = this;
          $rootScope.appMenu = this;
          window.APPMENU = this;
          if (window.appMenuOpen) this.open();
        }
      ]
    };
  }
]);



// WEBPACK FOOTER //
// ./src/apps/shared/menu/menu.js